module.exports = __webpack_public_path__ + "static/media/22904565_1638434059565112_5189920314499848186_o-thumb.8b1513db.jpg";